import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button, Col, Row } from "react-bootstrap";
import { contactServices } from "../../APIServices/SitePilotManagement/contactServices";
import { userServices } from "../../APIServices/UserData/userServices";
import Swal from "sweetalert2";
import { GoTrash } from "react-icons/go";
import { CiSquarePlus } from "react-icons/ci";

const UpdateContact = ({ show, hide, title, getContactList, contactId }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [social, setSocial] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState([]);
  const [address, setAddress] = useState("");
  const [countryId, setCountryId] = useState("")
  const [inboxId, setInboxId] = useState("")
  const [countryList, setCountryList] = useState([])
  const [loader, setLoader] = useState(false);

  const updatedContact = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this contact details?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.contactId = contactId
        userData.name = name
        userData.email = email
        userData.phone = phone
        userData.companyName = companyName
        userData.additionalType = true
        userData.additionalInfo = additionalInfo
        userData.socialType = true
        userData.social = social
        userData.address = address
        userData.countryId = countryId
        let data = await contactServices.updatedContact(userData)
        if (data?.statusCode === 200) {
          getContactList()
          clearData();
        }
        setLoader(false)
      }
    });
  };

  const getCountries = async () => {
    let data = await userServices.getCountries()
    setCountryList(data?.data || [])
  }

  const getSingleContact = async () => {
    let data = await contactServices.getSingleContact(contactId)
    setName(data?.data?.name);
    setEmail(data?.data?.email);
    setInboxId(data?.data?.inboxId || "");
    setPhone(data?.data?.phone || "");
    setCompanyName(data?.data?.companyName || "");
    setSocial(data?.data?.social || []);
    setAdditionalInfo(data?.data?.additionalInfo || []);
    setAddress(data?.data?.address || "");
    setCountryId(data?.data?.countryId || "");
  }

  const clearData = () => {
    setName("");
    setEmail("");
    setPhone("");
    setCompanyName("");
    setSocial([]);
    setAdditionalInfo([]);
    setAddress("");
    setCountryId("");
    setLoader(false)
    hide();
  }

  const addSocialRow = () => {
    setSocial([...social, { title: "", url: "" }]);
  };

  const removeSocialRow = (index) => {
    const updated = [...social];
    updated.splice(index, 1);
    setSocial(updated);
  };

  const handleSocialChange = (index, field, value) => {
    const updated = [...social];
    updated[index][field] = value;
    setSocial(updated);
  };

  const addAdditionalInfoRow = () => {
    setAdditionalInfo([...additionalInfo, { label: "", value: "" }]);
  };

  const removeAdditionalInfoRow = (index) => {
    const updated = [...additionalInfo];
    updated.splice(index, 1);
    setAdditionalInfo(updated);
  };

  const handleAdditionalInfoChange = (index, field, value) => {
    const updated = [...additionalInfo];
    updated[index][field] = value;
    setAdditionalInfo(updated);
  };

  const hasEmptySocialLinks = () => {
    if (
      social.length === 1 &&
      !social[0].title &&
      !social[0].url
    ) {
      return false;
    }
    return social.some(
      (item) =>
        !item.title?.trim() || !item.url?.trim()
    );
  };

  const hasEmptyAdditionalInfo = () => {
    if (
      additionalInfo.length === 1 &&
      !additionalInfo[0].label &&
      !additionalInfo[0].value
    ) {
      return false;
    }
    return additionalInfo.some(
      (item) =>
        !item.label?.trim() || !item.value?.trim()
    );
  };

  useEffect(() => {
    if (show) {
      getCountries()
    }
  }, [show]);

  useEffect(() => {
    if (show && contactId) {
      getSingleContact()
    }
  }, [show, contactId]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end" style={{ width: 650 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="name"
              type="text"
              value={name}
              disabled={!!inboxId}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="email"
              type="email"
              value={email}
              disabled={!!inboxId}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Phone
            </Form.Label>
            <Form.Control
              name="phone"
              type="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Enter Phone"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Company Name
            </Form.Label>
            <Form.Control
              name="company"
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="Enter Company Name"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Country
            </Form.Label>
            <Form.Select
              onChange={(e) => setCountryId(e.target.value)}
              value={countryId}
            >
              <option value={""}>Select Country</option>
              {countryList?.map((item => (
                <option value={item?.iso2}>{item?.name}</option>
              )))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Address
            </Form.Label>
            <Form.Control
              name="address"
              value={address}
              as="textarea"
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Enter Address"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <div className="hstack gap-2">
              <Form.Label>Social Media Links</Form.Label>
              <CiSquarePlus title="Add More" className="mb-1 text-success CP" onClick={addSocialRow} />
            </div>
            {social.map((item, index) => (
              <Row key={index} className="mb-2 align-items-center">
                <Col md={4}>
                  <Form.Control
                    placeholder="Enter Title"
                    value={item.title}
                    onChange={(e) =>
                      handleSocialChange(index, "title", e.target.value)
                    }
                  />
                </Col>
                <Col md={7}>
                  <Form.Control
                    placeholder="Enter URL"
                    value={item.url}
                    onChange={(e) =>
                      handleSocialChange(index, "url", e.target.value)
                    }
                  />
                </Col>
                <Col md={1}>
                  <GoTrash
                    style={{ fontSize: 15 }}
                    className="text-danger CP"
                    title="Delete"
                    onClick={() => removeSocialRow(index)} />
                </Col>
              </Row>
            ))}
          </Form.Group>
          <Form.Group className="mb-2">
            <div className="hstack gap-2">
              <Form.Label>Additional Information</Form.Label>
              <CiSquarePlus title="Add More" className="mb-1 text-success CP" onClick={addAdditionalInfoRow} />
            </div>
            {additionalInfo.map((item, index) => (
              <Row key={index} className="mb-2 align-items-center">
                <Col md={4}>
                  <Form.Control
                    placeholder="Enter Label"
                    value={item.label}
                    onChange={(e) =>
                      handleAdditionalInfoChange(index, "label", e.target.value)
                    }
                  />
                </Col>
                <Col md={7}>
                  <Form.Control
                    placeholder="Enter Value"
                    value={item.value}
                    onChange={(e) =>
                      handleAdditionalInfoChange(index, "value", e.target.value)
                    }
                  />
                </Col>
                <Col md={1}>
                  <GoTrash
                    style={{ fontSize: 15 }}
                    className="text-danger CP"
                    title="Delete"
                    onClick={() => removeAdditionalInfoRow(index)} />
                </Col>
              </Row>
            ))}
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={clearData} style={{ fontSize: 12 }} variant="light" >
              Cancel
            </Button>
            <Button
              disabled={!name || !email || hasEmptySocialLinks() || hasEmptyAdditionalInfo() || loader}
              onClick={updatedContact}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default UpdateContact;
